__turbopack_context__.v({
  "anchorItem": "E6e4Vq_anchorItem",
  "anchorLinks": "E6e4Vq_anchorLinks",
  "anchorPanel": "E6e4Vq_anchorPanel",
  "lightMode": "E6e4Vq_lightMode",
  "link": "E6e4Vq_link",
  "scrollButton": "E6e4Vq_scrollButton",
});
